<template>
  <div class="skeleton-card">
    <div class="skeleton-header">
      <div class="skeleton-rank"></div>
      <div class="skeleton-name"></div>
    </div>
    <div class="skeleton-stats">
      <div class="skeleton-stat"></div>
      <div class="skeleton-stat"></div>
      <div class="skeleton-stat"></div>
    </div>
  </div>
</template>

<style scoped>
.skeleton-card {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 184, 28, 0.2);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  overflow: hidden;
  position: relative;
}

.skeleton-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 184, 28, 0.1),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.skeleton-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.skeleton-rank {
  width: 40px;
  height: 40px;
  background: rgba(255, 184, 28, 0.2);
  border-radius: 50%;
}

.skeleton-name {
  flex: 1;
  height: 24px;
  background: rgba(255, 184, 28, 0.2);
  border-radius: 4px;
}

.skeleton-stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.skeleton-stat {
  flex: 1;
  min-width: 80px;
  height: 20px;
  background: rgba(255, 184, 28, 0.15);
  border-radius: 4px;
}

/* Desktop table skeleton */
@media (min-width: 769px) {
  .skeleton-card {
    display: table-row;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
  }
  
  .skeleton-card::after {
    display: none;
  }
  
  .skeleton-header,
  .skeleton-stats {
    display: table-cell;
    padding: 12px;
  }
  
  .skeleton-rank,
  .skeleton-name,
  .skeleton-stat {
    background: rgba(255, 184, 28, 0.2);
  }
}
</style>
